import { FormInModal } from "@/shared/form/form-in-modal";
import { AddButton } from "@/shared/form/button";
import { useTranslations } from "use-intl";
import { SaveCompanyDocumentFolderForm } from "./save-company-document-folder-form";

export function AddCompanyDocumentFolder({
  parentId,
  trigger,
}: {
  parentId?: string | null;
  trigger?: (open: () => void) => React.ReactNode;
}) {
  const t = useTranslations("CompanyDocumentFolder");

  return (
    <FormInModal
      title={t("Add folder")}
      trigger={
        trigger ??
        ((open) => <AddButton onClick={open}>{t("Add folder")}</AddButton>)
      }
      form={(close) => (
        <SaveCompanyDocumentFolderForm
          parentId={parentId}
          afterSubmit={close}
        />
      )}
    />
  );
}
